<template lang="pug">
	//- .pa-4.sud-card-header
	v-card-title.sud-card-header
		slot
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'app-card-header'
}
</script>

<style scoped>
.sud-card-header {
  background: #F0F0F0;
  height: 42px;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;

  color: #757575;
  border-radius: 5px 5px 0px 0px;
}
</style>
